import React from 'react';

import { useLocation, useNavigate } from 'react-router-dom';
import { deviceType } from '../../../utils/miscUtils';
import classes from './SidebarItem.module.css';
import { useAppDispatch, useAppSelector } from '../../../store/store';
import { selectDirtyState, setDirtyState } from '../../../store/slices/auth';
import { useTranslation } from '../../../hooks/useTranslations';

type Props = {
  label: string;
  navigateTo?: string;
  subItems?: SidebarSubItemsInfo[];
  icon: any;
  setIsExtended: () => void;
  notificationIndicator?: number;
};

interface SidebarSubItemsInfo {
  label: string;
  navigateTo: string;
}

const SidebarItem: React.FC<Props> = ({
  label,
  subItems,
  navigateTo,
  icon,
  setIsExtended,
  notificationIndicator,
}) => {
  const navigate = useNavigate();
  const { translations } = useTranslation();
  const { pathname } = useLocation();
  const [isExpanded, setIsExpanded] = React.useState<boolean>(false);
  const isDirtyState = useAppSelector<any>(selectDirtyState);
  const dispatch = useAppDispatch();

  const selected = React.useMemo(() => {
    if (navigateTo && pathname.includes(navigateTo)) {
      return true;
    }
    if (subItems) {
      for (let item of subItems) {
        if (pathname.includes(item.navigateTo)) {
          return true;
        }
      }
    }
    return false;
  }, [subItems, pathname]);

  const handleNavigate = (navigateTo: string) => {
    if (!isDirtyState.isDirty) {
      const isTablet = deviceType();
      if (['portrait', 'landscape'].includes(isTablet)) {
        setIsExtended();
      }
      navigate(navigateTo);
    } else {
      dispatch(setDirtyState({ isDirty: true, isModalOpen: true, component: '' }));
      return;
    }
  };

  return (
    <div className={classes.container}>
      <div
        className={`${classes.sidebarItem} ${selected ? classes.selectedItem : ''}`}
        onClick={() => {
          navigateTo
            ? handleNavigate(navigateTo)
            : setIsExpanded((prevIsExpanded) => !prevIsExpanded);
        }}
      >
        <div className={classes.wrapper}>
          <div className={classes.sidebarIconAndLabel}>
            <img src={icon} className={`${selected ? classes.invertImage : ''}`} alt="icon" />
            <div className={`${classes.sidebarLabel} ${selected ? classes.selectedLabel : ''}`}>
              {label}
            </div>
          </div>
          {Boolean(notificationIndicator) && (
            <div className={classes.notificationIndicator}>{notificationIndicator}</div>
          )}
        </div>
      </div>
      {isExpanded && subItems && (
        <div className={classes.subItems}>
          {subItems.map((subItem, index) => (
            <div
              key={subItem.label}
              className={`${classes.subItem} ${
                pathname === subItem.navigateTo ? classes.selectedSubItem : ''
              }`}
              onClick={() => handleNavigate(subItem.navigateTo)}
            >
              {translations(subItem.label)}
              {pathname === subItem.navigateTo && (
                <div className={classes.activeSubItemIndicator} />
              )}
              {/* {index + 1 !== subItems?.length && <div className={classes.subItemDivider} />} */}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SidebarItem;
